export const initializeSampleData = () => {
  const sampleShipments = [
    {
      id: 1,
      senderCity: 'Mumbai, Maharashtra',
      receiverCity: 'Delhi, NCR',
      courierType: 'Express Courier',
      estimatedDelivery: 'Jan 15, 2025',
      statusHistory: [
        {
          status: 'Order Placed',
          timestamp: '10 Jan 2025, 09:30 AM IST',
          location: 'Mumbai, Maharashtra'
        },
        {
          status: 'Picked Up',
          timestamp: '10 Jan 2025, 02:15 PM IST',
          location: 'Mumbai Hub'
        },
        {
          status: 'On Road to Warehouse (Shifting From)',
          timestamp: '10 Jan 2025, 06:45 PM IST',
          location: 'Mumbai to Pune Route'
        },
        {
          status: 'Moving (On Road/Transporting: Pune)',
          timestamp: '11 Jan 2025, 08:00 AM IST',
          location: 'Pune Transit Hub'
        },
        {
          status: 'Warehouse (Delivery Hub)',
          timestamp: '12 Jan 2025, 11:30 AM IST',
          location: 'Delhi Delivery Hub'
        },
        {
          status: 'Left For Delivery',
          timestamp: '13 Jan 2025, 07:00 AM IST',
          location: 'Delhi Local Delivery'
        },
        {
          status: 'Delivered',
          timestamp: '13 Jan 2025, 03:45 PM IST',
          location: 'Delhi, NCR'
        }
      ]
    },
    {
      id: 2,
      senderCity: 'Bangalore, Karnataka',
      receiverCity: 'Chennai, Tamil Nadu',
      courierType: 'Packers & Movers',
      estimatedDelivery: 'Jan 18, 2025',
      statusHistory: [
        {
          status: 'Order Placed',
          timestamp: '12 Jan 2025, 10:00 AM IST',
          location: 'Bangalore, Karnataka'
        },
        {
          status: 'Picked Up',
          timestamp: '12 Jan 2025, 04:30 PM IST',
          location: 'Bangalore Hub'
        },
        {
          status: 'On Road to Warehouse (Shifting From)',
          timestamp: '13 Jan 2025, 06:00 AM IST',
          location: 'Bangalore to Chennai Route'
        },
        {
          status: 'Moving (On Road/Transporting: Hosur)',
          timestamp: '13 Jan 2025, 12:00 PM IST',
          location: 'Hosur Transit Point'
        },
        {
          status: 'Warehouse (Delivery Hub)',
          timestamp: '14 Jan 2025, 09:00 AM IST',
          location: 'Chennai Delivery Hub'
        }
      ]
    },
    {
      id: 3,
      senderCity: 'Kolkata, West Bengal',
      receiverCity: 'Guwahati, Assam',
      courierType: 'Standard Courier',
      estimatedDelivery: 'Jan 20, 2025',
      statusHistory: [
        {
          status: 'Order Placed',
          timestamp: '13 Jan 2025, 11:15 AM IST',
          location: 'Kolkata, West Bengal'
        },
        {
          status: 'Picked Up',
          timestamp: '13 Jan 2025, 05:00 PM IST',
          location: 'Kolkata Hub'
        },
        {
          status: 'On Road to Warehouse (Shifting From)',
          timestamp: '14 Jan 2025, 07:30 AM IST',
          location: 'Kolkata to Guwahati Route'
        }
      ]
    },
    {
      id: 4,
      senderCity: 'Pune, Maharashtra',
      receiverCity: 'Jaipur, Rajasthan',
      courierType: 'Express Packers & Movers',
      estimatedDelivery: 'Jan 22, 2025',
      statusHistory: [
        {
          status: 'Order Placed',
          timestamp: '14 Jan 2025, 08:45 AM IST',
          location: 'Pune, Maharashtra'
        },
        {
          status: 'Picked Up',
          timestamp: '14 Jan 2025, 01:30 PM IST',
          location: 'Pune Hub'
        }
      ]
    },
    {
      id: 5,
      senderCity: 'Hyderabad, Telangana',
      receiverCity: 'Kochi, Kerala',
      courierType: 'Standard Courier',
      estimatedDelivery: null,
      statusHistory: [
        {
          status: 'Order Placed',
          timestamp: '10 Jan 2025, 09:00 AM IST',
          location: 'Hyderabad, Telangana'
        },
        {
          status: 'Picked Up',
          timestamp: '10 Jan 2025, 03:00 PM IST',
          location: 'Hyderabad Hub'
        },
        {
          status: 'On Road to Warehouse (Shifting From)',
          timestamp: '11 Jan 2025, 07:00 AM IST',
          location: 'Hyderabad to Bangalore Route'
        },
        {
          status: 'Moving (On Road/Transporting: Bangalore)',
          timestamp: '12 Jan 2025, 10:00 AM IST',
          location: 'Bangalore Transit Hub'
        },
        {
          status: 'Warehouse (Delivery Hub)',
          timestamp: '13 Jan 2025, 02:00 PM IST',
          location: 'Kochi Delivery Hub'
        },
        {
          status: 'Left For Delivery',
          timestamp: '14 Jan 2025, 08:00 AM IST',
          location: 'Kochi Local Delivery'
        },
        {
          status: 'Denied to Receive',
          timestamp: '14 Jan 2025, 11:30 AM IST',
          location: 'Kochi, Kerala'
        }
      ]
    }
  ];

  // Store sample data in localStorage if not already present
  sampleShipments.forEach(shipment => {
    const key = `shipment_${shipment.id}`;
    if (!localStorage.getItem(key)) {
      localStorage.setItem(key, JSON.stringify(shipment));
    }
  });
};